import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetDriverAppFulfilmentServiceCodesQuery, VehicleTypeFilter } from 'generated/graphql'

import { DriverAppFulfilmentFilterValues } from './DriverAppFulfilmentFilterCriteria'
import { useDriverAppFulfilmentQueryInput } from './useDriverAppFulfilmentQueryInput'

export const DriverAppFulfilmentServiceCodeAutocomplete = () => {
  const { control } = useFormContext<DriverAppFulfilmentFilterValues>()
  const { start, end } = useDriverAppFulfilmentQueryInput()

  const { data } = useGetDriverAppFulfilmentServiceCodesQuery({
    variables: { input: { start, end, vehicleType: VehicleTypeFilter.All } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.driverAppFulfilmentServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={2}
      size='small'
      sx={{ minWidth: 180 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
